import { assertNever } from '@sparkdotfi/common-universal'

import { SavingsBackedByData } from '@/config/chain/types'

export { darkenColor, formatChartValue, formatPieChartValue, getPalletteColor } from '../common/chart-utils'

export const tokenColorsBySymbol = {
  USDS: '#FFA54D',
  USDT: '#27A17B',
  USDC: '#2675CA',
  PYUSD: '#2471F3',
} as const

export function getTokenColorBySymbol(symbol: string): string | undefined {
  return tokenColorsBySymbol[symbol as keyof typeof tokenColorsBySymbol]
}

export function mapCategoryToLabel(category: SavingsBackedByData[number]['category']): string {
  switch (category) {
    case 'aaa_corporate_debt':
      return 'AAA Corporate Debt'
    case 'basis_trade':
      return 'Basis Trade'
    case 'onchain_crypto_lending':
      return 'Onchain Crypto Lending'
    case 'otc_crypto_lending':
      return 'OTC Crypto Lending'
    case 'short_duration_treasury_bills':
      return 'Short Duration Treasury Bills'
    case 'stablecoins':
      return 'Stablecoins'
    case 'idle':
      return 'Vault Liquidity'
    case 'sparklend_eth':
      return 'Sparklend ETH'
    case 'private_credit':
      return 'Private Credit'
    case 'basis_trade_cme':
      return 'Basis Trade (CME)'
    case 'other':
      return 'Other'
    default:
      assertNever(category)
  }
}
